import React, {useEffect, useRef, Suspense, lazy} from 'react';
import Provider from './Provider';
import { useDialogues } from '.';

const Dialogues = lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "ui-components" */'./Dialogues'));

const Wrapper = ({children}) => {

    return <Provider>
        <Inner>
            {children}
        </Inner>
        <Suspense fallback={null}>
            <Dialogues />
        </Suspense>
    </Provider>
}

const Inner = ({children}) => {
    const {inert} = useDialogues();

    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) {
            return;
        }

        if (inert) {
            containerRef.current.setAttribute('inert', '');
        } else {
            containerRef.current.removeAttribute('inert');
        }
    }, [inert]);

    return <div className="contents" ref={containerRef}>
        {children}
    </div>
}

export default Wrapper;
